module.exports = __webpack_public_path__ + "img/globe-nav-chevron-right-fullGrey.338c05af.svg";